<section>
  <h2>Cookie policy</h2>
  Please read this cookie policy carefully before using the <a href="https://apps.cosy.bio/academate">cosy.bio</a> our
  website
  operated by <a href="https://cosy.bio">cosy.bio</a>.
  <h3> What are cookies?</h3>
  Cookies are simple text files that are stored on your computer or mobile device by a website’s
  server. Each cookie is unique to your web browser. It will contain some anonymous information
  such as a unique identifier, website’s domain name, and some digits and numbers.
  What types of cookies do we use?

  <h3>Necessary cookies</h3>

  Necessary cookies allow us to offer you the best possible experience when accessing and
  navigating through our website and using its features. For example, these cookies let us
  recognize that you have created an account and have logged into that account.

  <h3>What we store</h3>
  We do not use cookies on our website. Instead, we utilize your browser’s local storage to securely store your personal
  keys and randomly generated user IDs. These identifiers are included automatically in each request header sent to our
  service to facilitate secure and personalized access. However, they are never stored, logged, or saved on our servers.
  This method ensures an optimal, privacy-conscious user experience while keeping your data exclusively within your
  control and securely on your own device.

  <h3> Contacting us</h3>
  If you have any questions about this policy or our use of cookies, please contact us.
  Save your time and take the guesswork out of the legal jargon with our smart generators.
  Create a cookie policy and a cookie consent banner personalized to your needs in minutes.
</section>
